import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Timmer, DaumPost } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:소매화원가입
 * 세부설명:
*/

export class MemberReg extends Component {
    static displayName = MemberReg.name;
    constructor(props) {
        super(props);
        this.state = {
            MemberModel: {
                User_Name: "",
                User_Phone: "",
                Certifi_No: "",
                Login_Id: "",
                Password: "",
                PasswordCheck: "",
                Org_No: "",
                Org_Name: "",
                Depo_Name: "",
                Post_No: "",
                Addr_1: "",
                Addr_2: "",
                Agreement_Yn1: false,
                Agreement_Yn2: false,
                Optionagr_Yn: false,
                Buyer_Uid: "",              //사입자 아이디
                BuyerPhone: "",             //사입자연락처
                OutBuyerPhone:""            //외부 사입자 연락처--> 소매에 거래 사입이 있지만 클로디 사입자는 아닌 사입자
            },
            LabelMsg: {
                User_Phone_Show: false,
                User_Phone_Msg: "",
                User_Phone_Css: "",
                Certifi_No_Show: false,
                Certifi_No_Msg: "",
                Certifi_No_Css: "",
                Login_Id_Show: false,
                Login_Id_Msg: "",
                Login_Id_Css: "",
                Password_Show: false,
                Password_Msg: "",
                Password_Msg_Css: "",
                PasswordCheck_Show: false,
                Org_No_Show: false,
                BuyerPhone_Show: false,
                BuyerPhone_Msg: "",
                BuyerPhone_Msg_Css: ""
            },
            Title: "",
            Content:"",
            BuyerSelectYn: "N",        //사입자 여부  
            Buyer_Org_Name: "",        //사입자 이름
            Buyer_Name: "",            //사입자 지역
            Area_Name:"",              //지역명
            isEyeText: "password",
            isEyeOpen: false,
            isEyeCheckText: "password",
            isEyeCheckOpen: false,

            Login_IdOK: false,        //아이디 확인
            SeqNo: "",                // 인증번호 발송 Seq
            isCertifiClick: false,    //인증버튼 재클릭 금지
            CertifiNumberOk: false,   //인증성공여부
            RegisterSuccess: false,   //회원가입 완료
            Certifi_Css: "item_hide",  // 인증번호 입력 가능 보이기

            ExistBuyerBtnYn: "",         //사입삼촌 있어요 여부
            TradeBuyerBtnYn:"Y"          // 거래중 삼촌 여부
        };
        this.refTimmer = React.createRef();
        this.handle_Change = this.handle_Change.bind(this);
        this.handle_Blur = this.handle_Blur.bind(this);
        this.handleEye_Click = this.handleEye_Click.bind(this);
        this.handleCertifiSend = this.handleCertifiSend.bind(this);
        this.handleCertifi_Click = this.handleCertifi_Click.bind(this);
        this.handleBusinessFile = this.handleBusinessFile.bind(this);
        this.handlePost_Click = this.handlePost_Click.bind(this);
        this.initData = this.initData.bind(this);
        this.handleBuyerSearch_Click = this.handleBuyerSearch_Click.bind(this);
        this.handelCancel_Click = this.handelCancel_Click.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleAlert_Click = this.handleAlert_Click.bind(this);
        this.handelTermsofservice_Click = this.handelTermsofservice_Click.bind(this);
        this.handleBuyerOpen_Click = this.handleBuyerOpen_Click.bind(this);
        this.handleRecommand_Click = this.handleRecommand_Click.bind(this);
        this.handleTsMatch_Click = this.handleTsMatch_Click.bind(this);

        this.Org_File_Grp = "";
    }
    //초기화
    async componentDidMount() {
        //첨부파일 구룹키
        const FileGrpKey = Big3Common.WebStorage.GetSessionStorage(Big3Common.WebStorage.StorageName.FileGrpKey);
        if (FileGrpKey !== null) {
            this.Org_File_Grp = FileGrpKey;
        }
        //첨부파일 등록 후 이전 등록된 값 셋팅
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            let StateList = this.props.ContentState;
            await Object.keys(StateList).map(key => {
                let objValue = StateList[key];

                if (key === "MemberModel" || key ==="LabelMsg") {
                    Big3Common.updateStateModel({ this: this, modelName: key, updateModel: objValue });
                }
                else {
                    this.setState({ [key]: objValue });
                }
                return false;
            });
        }

    }
    handle_Change(event,MaxLength=20) {

        //이름은 한글/영문만 입력 되게 처리
        const tagId = event.target.id;
        const value = event.target.value.trim();
        if (tagId === "User_Phone" || tagId === "Certifi_No" || tagId === "Org_No" || tagId === "BuyerPhone" || tagId ==="OutBuyerPhone") {
           
            //핸드폰,인증번호 숫자만 입력 되게 처리
            const StringText = value.replace(/-/gi, '');
            const StringLength = StringText.length;
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
            if (StringLength > MaxLength) {
                return false;
            }
        }
        else if (tagId === "Agreement_All") {
            const checked = event.target.checked;
            Big3Common.updateStateModel({
                this: this,
                modelName: "MemberModel",
                updateModel: {
                    "Agreement_Yn1": checked,
                    "Agreement_Yn2": checked,
                    "Optionagr_Yn": checked
                }
            });
        }
        if (value.length === 0) {
            this.UpdateStateModel(tagId, false, "");
        }
        Big3Common.ValueCahage_StateUpdate({ this: this, event: event, modelName: "MemberModel" });
        return false;
    }
    //메세지 모델 업데이트
    UpdateStateModel(TagId,isShow,Message="",Css="input_txt") {
        Big3Common.updateStateModel({
            this: this,
            modelName: "LabelMsg",
            updateModel: {
                [`${TagId}_Show`]: isShow,
                [`${TagId}_Msg`]: Message,
                [`${TagId}_Css`]: Css,
            }
        });
    }
        
    //기본 값 검증
    async handle_Blur(event) {

        const tagId = event.target.id;        
        let value = event.target.value.trim();
        if (value.length === 0) return false;
        if (tagId === "User_Phone") {
            
            const isCheck = Big3Common.Util.HandPhoneCheck(value);
            if (!isCheck) {
                this.UpdateStateModel(tagId, true, "핸드폰번호 형식이 잘못 되었습니다.");
            }
            else {
                const hpFormat = Big3Common.Util.HandPhoneFormat(value);
                let Data = await Big3Common.Post("api/Common/Common/PhoneNumberValid", {
                    "user_phone": hpFormat,
                    "reg_type": "BC"
                });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    //핸드폰 중복체크 하고 성공이면 아래 로직
                    Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: hpFormat } });
                    this.UpdateStateModel(tagId, true, "인증번호 전송 버튼을 클릭하세요.","input_txt2");
                }
                else {
                    this.UpdateStateModel(tagId, true, Data.message);
                }
            }
        }
        else if (tagId === "BuyerPhone" || tagId ==="OutBuyerPhone") {
            const isCheck = Big3Common.Util.HandPhoneCheck(value);
            if (!isCheck) {
                this.UpdateStateModel(tagId, true, "핸드폰번호 형식이 잘못 되었습니다.");
            }
            else {
                const hpFormat = Big3Common.Util.HandPhoneFormat(value);
                Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: hpFormat } });
            }
        }
        else if (tagId === "Login_Id") {
            const isCheck = Big3Common.Util.isUserIdValid(value);
            if (!isCheck) {
                this.UpdateStateModel(tagId, true, "문자/숫자 조합 최소 8자리를 입력해주세요.");
            }
            else {
                //아이디 서버에서 중복검사
                try {
                    let Data = await Big3Common.Post("api/Common/Common/LoginIdValid", { "login_id": this.state.MemberModel.Login_Id });
                    if (Data.codeName === Big3Common.ResultCode.Success) {
                        this.setState({ Login_IdOK: true });
                        this.UpdateStateModel(tagId, true, Data.message,"input_txt2");
                    }
                    else {
                        this.setState({ Login_IdOK: false });
                        this.UpdateStateModel(tagId, true, Data.message);
                    }
                   
                }
                catch (e) {
                    console.log("handle_Blur:", e);
                }
            }
        }
        else if (tagId === "Password") {
            const isCheck = Big3Common.Util.isPassWordValid(value);
            if (!isCheck) {
                this.UpdateStateModel(tagId, true, "영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요.");
            }
            else {
                this.UpdateStateModel(tagId, false, "");
            }
        }
        else if (tagId === "PasswordCheck") {
            if (this.state.MemberModel.Password !== this.state.MemberModel.PasswordCheck) {
                this.UpdateStateModel(tagId, true);
            }
            else {
                this.UpdateStateModel(tagId, false);
            }
        }
        else if (tagId === "Org_No") {
            const isCheck = Big3Common.Util.OrgNumberCheck(value);
            if (isCheck) {
                const orgFormat = Big3Common.Util.OrgNumberFormat(value);
                Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: orgFormat } });
            }
            this.UpdateStateModel(tagId, !isCheck);
        }
        event.preventDefault();
    }
    //비밀번호 보이기
    handleEye_Click(isEye) {
        if (isEye === "isEyeOpen") {
            if (this.state.isEyeOpen === false) {
                this.setState({ isEyeOpen: true, isEyeText: "text" });
            }
            else {
                this.setState({ isEyeOpen: false, isEyeText: "password" });
            }
        }
        if (isEye === "isEyeCheckOpen") {
            if (this.state.isEyeCheckOpen === false) {
                this.setState({ isEyeCheckOpen: true, isEyeCheckText: "text" });
            }
            else {
                this.setState({ isEyeCheckOpen: false, isEyeCheckText: "password" });
            }
        }
        return false;
    }
    //인증번호 전송
    async handleCertifiSend(event) {
        const tagId = "User_Phone";
        const User_Phone = this.state.MemberModel[tagId];
        const isCheck = Big3Common.Util.HandPhoneCheck(User_Phone);
        if (User_Phone.length === 0 || !isCheck) {
            this.UpdateStateModel("User_Phone", true, "핸드폰 번호를 확인하여 주세요.");
        }
        else {

            //인증번호 전송되었으면 클릭 금지
            if (this.state.isCertifiClick) {
                return false;
            }
            try {
                const hpFormat = Big3Common.Util.HandPhoneFormat(User_Phone);
                let Data = await Big3Common.Post("api/Common/Common/Certifino", {
                    "user_phone": hpFormat,
                    "reg_type": "BC"
                });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let seqno = Data.objectData;
                    this.setState({
                        "SeqNo": seqno,
                        "isCertifiClick": true,
                        Certifi_Css: "input_line" 
                    });
                    //인증번호 전송 후 타이머 쇼
                    this.refTimmer.current.Play();
                }
                else {
                    this.UpdateStateModel(tagId, true, Data.message);
                }
            }
            catch (e) {
                console.log("handleCertifiSend: ", e);
            }
        }
        event.preventDefault();
    }
    //인증번호 검증
    async handleCertifi_Click(event) {

        const tagId = "Certifi_No";
        if (this.state.CertifiNumberOk === true) {
            //이미 인증했음.
            return false;
        }
        if (this.refTimmer.current.isTimeOut()) {            
            this.setState({
                "SeqNo": "",
                "isCertifiClick": false,
                "Certifi_No_Show": true,
                "Certifi_No_Msg" : "입력시간이 초과되었습니다. 인증번호 받기를 다시 진행해주세요."
            });
        }
        else if (this.state.MemberModel.Certifi_No.trim().length === 0) {
            this.UpdateStateModel(tagId, true, "인증번호를 입력하여 주세요.");
        }
        else {

            try {
                let Data = await Big3Common.Post("api/Common/Common/CertifinoVerification",
                    {
                        "seqno": this.state.SeqNo,
                        "certifi_no": this.state.MemberModel.Certifi_No
                    });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    //인증성공
                    this.refTimmer.current.Stop();
                    this.UpdateStateModel(tagId, true, Data.message,"input_txt2");
                    this.setState({ "CertifiNumberOk": true });
                }
                else if (Data.codeName === Big3Common.ResultCode.Warning) {
                    //인증번호 불일치
                    this.UpdateStateModel(tagId, true, Data.message);
                }
                else {
                    //오류
                    this.UpdateStateModel(tagId, true, Data.message);
                    this.setState({ "SeqNo": "", "isCertifiClick": false });
                }
            }
            catch (e) {
                console.log("handleCertifiValid :", e);
            }
        }
        event.preventDefault();
    }
    //우편번호 검색
    handlePost_Click(Zoneode, Address) {
        Big3Common.updateStateModel({
            this: this,
            modelName: "MemberModel",
            updateModel: {
                Post_No: Zoneode,
                Addr_1: Address
            }
        });
        Big3Common.ModalClose(bootstrap, 'DaumPost');
        return false;
    }
    //사입자 검색
    async handleBuyerSearch_Click(event) {
        const tagId = "BuyerPhone";
        const BuyerPhone = this.state.MemberModel[tagId];
        if (BuyerPhone.length === 0) {
            this.UpdateStateModel(tagId, true, "사입자 전화번호를 등록하세요");
            return false;
        }
        const isCheck = Big3Common.Util.HandPhoneCheck(BuyerPhone);
        if (!isCheck) {
            this.UpdateStateModel(tagId, true, "핸드폰번호 형식이 잘못 되었습니다.");
            return false;
        }
        try {
            Big3Common.Util.LoadingOn();
            const hpFormat = Big3Common.Util.HandPhoneFormat(this.state.MemberModel.BuyerPhone);
            let Data = await Big3Common.Post('api/Account/MemberMgr/GetBuyerInfo', { BuyerPhone: hpFormat } , true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const Info = JSON.parse(Data.dataTable);
                if (Info.length > 0) {
                    Big3Common.updateStateModel({
                        this: this,
                        modelName: "MemberModel",
                        updateModel: {
                            Buyer_Uid: Info[0].buyer_uid
                        }
                    });
                    this.setState({
                        Buyer_Org_Name: Info[0].buyer_org_name,
                        Buyer_Name: Info[0].buyer_name,
                        Area_Name: `(${Info[0].area_name})`,
                        TradeBuyerBtnYn: "Y",
                        BuyerSelectYn:"Y"
                    });
                    this.UpdateStateModel(tagId, false, "");
                }
                else {
                    Big3Common.updateStateModel({
                        this: this,
                        modelName: "MemberModel",
                        updateModel: {
                            OutBuyerPhone: hpFormat
                        }
                    });
                    this.setState({
                        TradeBuyerBtnYn: "N",
                        BuyerSelectYn:"N"
                    });
                    this.UpdateStateModel(tagId, true,"사입자 정보가 없습니다.");
                }
            }
            else {
                this.UpdateStateModel(tagId, true, Data.message);
            }
        }
        catch (e) {
            console.log("handleBuyerSearch_Click", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //사입자 찾기 취소
    handelCancel_Click() {
        this.initData();
        Big3Common.ModalClose(bootstrap, "FindBuyer");
        return false;
    }
    //사입자 찾기팝업 오픈
    handleBuyerOpen_Click(event) {
        this.initData();
        Big3Common.ModalAlert(bootstrap, 'FindBuyer');
        event.preventDefault();
    }
    initData() {
        Big3Common.updateStateModel({
            this: this,
            modelName: "MemberModel",
            updateModel: {
                Buyer_Uid: "",
                BuyerPhone: "",
                OutBuyerPhone: ""
            }
        });
        this.setState({
            BuyerSelectYn: "N",
            Buyer_Org_Name: "",
            Buyer_Name: "",
            ExistBuyerBtnYn: "",
            TradeBuyerBtnYn: "Y"
        });
    }
    //추천하기
    handleRecommand_Click(event) {
        const OutBuyerPhone = this.state.MemberModel.OutBuyerPhone;
        if (OutBuyerPhone === "") {
            this.setState({ Title: "추천 사입삼촌 연락처를 입력해 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        const isCheck = Big3Common.Util.HandPhoneCheck(OutBuyerPhone);
        if (!isCheck) {
            this.setState({ Title: "연락처 형식이 잘못 되었습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        this.setState({
            BuyerSelectYn: "N",
            Buyer_Org_Name: OutBuyerPhone
        });
        Big3Common.ModalClose(bootstrap, "FindBuyer"); 
        event.preventDefault();
    }
    //택배삼촌 매칭 가입하기
    async handleTsMatch_Click(event) {
        try {

            let Data = await Big3Common.Post('api/Account/MemberMgr/GetTsUid', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                this.setState({
                    BuyerSelectYn: "Y",
                    Buyer_Org_Name: DataList[0].org_name
                });
                Big3Common.updateStateModel({
                    this: this,
                    modelName: "MemberModel",
                    updateModel: {
                        Buyer_Uid: DataList[0].uid
                    }
                });
            }
        }
        catch (e) {
            console.log("handleTsMatch_Click", e);
        }
        event.preventDefault();
    }
    //사업자 등록증 등록
    handleBusinessFile(event) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["LabelMsg"]);
        this.props.RenderComponent('BusinessInfo', StateCopy);
        event.preventDefault();
    }
    //서비스이용약관
    handelTermsofservice_Click(ComponentName) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["LabelMsg"]);
        this.props.RenderComponent(ComponentName, StateCopy);
    }
    handleAlert_Click() {
        if (this.state.RegisterSuccess) {
            window.location.href = "/Account/LoginMgr/Index";
        }
    }    
    async handleSave_Click(event) {
        
        let AlertMsg = "";
        if (this.state.MemberModel.User_Name.trim() === "") {
            AlertMsg = "대표자명을 입력하세요."
        }
        else if (this.state.MemberModel.User_Phone.trim() === "") {
            AlertMsg = "휴대폰 번호을 입력하세요."
        }
        else if (Big3Common.Util.HandPhoneCheck(this.state.MemberModel.User_Phone) === false) {
            AlertMsg = "휴대폰 번호형식을 확인하여 주세요."
        }
        else if (this.state.CertifiNumberOk === false)
        {
            AlertMsg = "휴대번호 인증을 하여주세요.";
        }
        else if (this.state.MemberModel.Login_Id.trim() === "") {
            AlertMsg = "아이디를 입력하세요."
        }
        else if (Big3Common.Util.isUserIdValid(this.state.MemberModel.Login_Id) === false) {
            AlertMsg = "문자/숫자 조합 최소 8자리를 입력해주세요."
        }
        else if (this.state.MemberModel.Password.trim() === "") {
            AlertMsg = "비밀번호를 입력하세요."
        }
        else if (Big3Common.Util.isPassWordValid(this.state.MemberModel.Password) === false) {
            AlertMsg = "영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요."
        }
        else if (this.state.MemberModel.PasswordCheck.trim() === "") {
            AlertMsg = "비밀번호 확인을 입력하세요."
        }
        else if (this.state.MemberModel.Password.trim() !== this.state.MemberModel.PasswordCheck.trim()) {
            AlertMsg = "비밀번호가 일치하지 않습니다."
        }
        else if (this.state.MemberModel.Org_No.trim() === "") {
            AlertMsg = "사업자등록번호를 입력하세요."
        }
        else if (Big3Common.Util.OrgNumberCheck(this.state.MemberModel.Org_No) === false) {
            AlertMsg = "사업자등록번호 형식을 확인하여 주세요."
        }
        else if (this.Org_File_Grp === ""){
            AlertMsg = "사업자등록증을 첨부하여 주세요."
        }
        else if (this.state.MemberModel.Org_Name.trim() === "") {
            AlertMsg = "상호명을 입력하세요."
        }
        else if (this.state.BuyerSelectYn === "Y" && this.state.MemberModel.Buyer_Uid.trim() === "") {
            AlertMsg = "사입자명을 등록하세요."
        }
        else if (this.state.MemberModel.Depo_Name.trim() === "") {
            AlertMsg = "입금자명을 등록하세요."
        }
        else if (this.state.MemberModel.Post_No.trim() === "") {
            AlertMsg = "우편번호를 등록하세요."
        }
        else if (this.state.MemberModel.Addr_1.trim() === "") {
            AlertMsg = "주소를 등록하세요."
        }
        else if (this.state.MemberModel.Addr_2.trim() === "") {
            AlertMsg = "상세 주소를 등록하세요."
        }
        else if (this.state.MemberModel.Agreement_Yn1 === false) {
            AlertMsg = "서비스 이용약관에 동의해주세요."
        }
        else if (this.state.MemberModel.Agreement_Yn2 === false) {
            AlertMsg = "개인정보처리방침에 동의해주세요."
        }
        if (AlertMsg !== "") {
            this.setState({ Title: AlertMsg });
            Big3Common.ModalAlert(bootstrap, "MessageAlert");
            return false;
        }
        else {
            //회원정보 저장
            try {
                let MemberModel = this.state.MemberModel;
                MemberModel.Org_File_Grp = this.Org_File_Grp;
                MemberModel.BuyerSelectYn = this.state.BuyerSelectYn;

                const hpFormat = Big3Common.Util.HandPhoneFormat(this.state.MemberModel.User_Phone);
                MemberModel.User_Phone = hpFormat;

                const orgFormat = Big3Common.Util.OrgNumberFormat(this.state.MemberModel.Org_No);
                MemberModel.Org_No = orgFormat;
                MemberModel.SeqNo = this.state.SeqNo;

                let Data = await Big3Common.Post("api/Account/MemberMgr/MemberSave", MemberModel, true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.setState({ Title: "회원가입 요청이 완료되었습니다.", Content: "승인까지 영업일 기준 2~3정도 소요됩니다.", RegisterSuccess: true });
                }
                else {
                    this.setState({ Title: "회원가입 오류", Content: Data.message });
                }
            }
            catch (e) {
                console.log("handleSave :", e);
            }
            finally {
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                
            }
        }
        event.preventDefault();
    }
   
    Buyerrender2() {
        
        return (
            <div className="modal fade" id="FindBuyer" tabIndex="-1" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content ordertype_modal">
                        <div className="modal-body text-center ">
                            <div className="desc ordertype_modal_in">
                                <div className="modal_title">사입삼촌 선택</div>
                            </div>
                            <div className="c_box">
                                <div onClick={() => { this.setState({ ExistBuyerBtnYn: "Y" }); }} className={this.state.ExistBuyerBtnYn === "Y" ? "choise" : ""}>거래하고 있는<br />사입삼촌 있어요</div>
                                <div onClick={() => { this.setState({ ExistBuyerBtnYn: "N" }); }} className={this.state.ExistBuyerBtnYn === "N" ? "choise" : ""}>거래하고 있는<br />사입삼촌 없어요</div>
                            </div>
                            {/*<!--삼촌있음- 매칭성공-->*/}
                            <div className={this.state.ExistBuyerBtnYn === "Y" && this.state.TradeBuyerBtnYn === "Y" ? "case1" : "item_hide"}>
                                <div className="tit2">거래중인 사입삼촌 매칭</div>
                                <div className="category_slectbox">
                                    <div className="f_input_line">
                                        <input type="tel"
                                            placeholder="전화번호 검색(-는 제외)"
                                            id="BuyerPhone"
                                            maxLength="11"
                                            pattern="\d*"
                                            value={this.state.MemberModel.BuyerPhone}
                                            onChange={(e) => { this.handle_Change(e, 12); }}
                                            onBlur={this.handle_Blur}
                                        />
                                        <button onClick={this.handleBuyerSearch_Click}>검색</button>
                                    </div>
                                    <div className="Search_cont_v1">
                                        <p>업체명: {this.state.Buyer_Org_Name}</p>
                                        <p>사입자: {this.state.Buyer_Name} {this.state.Area_Name}</p>
                                    </div>
                                    <div className="Search_cont_v2">
                                        <ul>
                                            <li>사입삼촌은 현재 소매에서 거래 중이신 사입삼촌을 등록하시면 됩니다.</li>
                                            <li>사입삼촌이 조회되지 않는다면 해당 사입자는 클로디 회원이 아닌 상태입니다.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="ok_btn_box">
                                    <button onClick={() => { this.handelCancel_Click() }}>취소</button>
                                    <button onClick={() => { Big3Common.ModalClose(bootstrap, "FindBuyer"); }}>적용하기</button>
                                </div>
                            </div>
                            {/*  <!--삼촌있음- 매칭실패-->*/}
                            <div className={this.state.ExistBuyerBtnYn === "Y" && this.state.TradeBuyerBtnYn === "N" ? "case2" : "item_hide"}>
                                <div className="tit2">거래중인 사입삼촌 매칭</div>
                                <div className="category_slectbox">
                                    <div className="f_input_line">
                                        <input type="tel"
                                            placeholder="전화번호 검색(-는 제외)"
                                            id="BuyerPhone"
                                            maxLength="11"
                                            pattern="\d*"
                                            value={this.state.MemberModel.BuyerPhone}
                                            onChange={(e) => { this.handle_Change(e, 12); }}
                                            onBlur={this.handle_Blur}
                                        />
                                        <button onClick={this.handleBuyerSearch_Click}>검색</button>
                                    </div>
                                    <div className="f_input_txt">사입삼촌 정보가 없습니다.</div>
                                    <div className="Search_cont_v2">
                                        <ul>
                                            <li>사입삼촌은 현재 소매에서 거래 중이신 사입삼촌을 등록하시면 됩니다.</li>
                                            <li className="Em">해당 사입자는 클로디 회원이 아닌 상태입니다.</li>
                                            <li className="Em">사입삼촌 매칭 없이 클로디 가입을 원하시면 '사입삼촌 없어요' 를 선택하여 진행해 주세요.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="bt2"></div>
                                <div className="tit2">거래중인 사입삼촌에게 클로디 추천하기</div>
                                <div className="Search_cont_v3">
                                    <p>클로디를 사용하면 사입삼촌의 업무가 편해집니다.</p>
                                    <p>주문누락을 방지하고, 믿을 수 있는 자동정산까지!</p>
                                    <p>사입삼촌에게 클로디를 추천해주세요.</p>
                                </div>
                                <div className="category_slectbox">
                                    <div className="f_input_line">
                                        <input type="tel"
                                            placeholder="사입삼촌 전화번호 입력(-는 제외)"
                                            id="OutBuyerPhone"
                                            maxLength="11"
                                            pattern="\d*"
                                            value={this.state.MemberModel.OutBuyerPhone}
                                            onChange={(e) => { this.handle_Change(e, 12); }}
                                            onBlur={this.handle_Blur}
                                        />
                                        <button onClick={(e) => { this.handleRecommand_Click(e); } }>추천하기</button>
                                    </div>
                                </div>
                            </div>
                            <div className={this.state.ExistBuyerBtnYn === "N" ? "case3" : "item_hide"}>
                                <div className="Search_cont_v2">
                                    <ul>
                                        <li>이용 중인 사입삼촌이 없을 경우 택배삼촌을 선택하셔야 합니다. 이후 사입삼촌 등록을 원하시면 변경 가능합니다.</li>
                                    </ul>
                                </div>
                                <div className="category_slectbox">
                                    <div className="ok_btn_box">
                                        <button className="one_btn" onClick={(e) => { this.handleTsMatch_Click(e); Big3Common.ModalClose(bootstrap, 'FindBuyer'); }}>택배삼촌 매칭 가입하기</button>
                                    </div>
                                </div>
                                <div className="d_info_txt">
                                    <span>택배삼촌을 선택</span>하시면 클로디팀과 연결된 택배삼촌이 알아서 수거해서 보내드려요.
                                </div>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                </div>
            </div>  
        )
    }
    render() {
        const Buyerrender = this.Buyerrender2();
        return (
            <div>
                <div className="join_box container-md">
                    <div className="input_line">
                        <label>대표자명</label>
                        <input type="text"
                            id="User_Name"
                            className="form-control"
                            maxLength="10"
                            placeholder="실명을 입력하세요"
                            value={this.state.MemberModel.User_Name}
                            onChange={this.handle_Change}
                            onBlur={this.handle_Blur}
                        />
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>휴대폰번호</label>
                        <div className="nc_box">
                            <input type="tel"
                                className="form-control cn_input"
                                maxLength="11" 
                                id="User_Phone"
                                pattern="\d*"
                                placeholder="휴대폰번호를 입력 (-는 제외)"
                                value={this.state.MemberModel.User_Phone}
                                onChange={(e) => {this.handle_Change(e,12);}}
                                onBlur={this.handle_Blur}
                            />
                            <button type="button" className={this.state.SeqNo === "" ? "cn_button btn_v1" : "cn_button btn_inactive"} onClick={this.handleCertifiSend}>인증번호 전송</button>
                        </div>
                        <div className={this.state.LabelMsg.User_Phone_Show ? this.state.LabelMsg.User_Phone_Css : "item_hide"}>{this.state.LabelMsg.User_Phone_Msg}</div>
                    </div>
                    <div className={this.state.Certifi_Css} >
                        <label>인증번호</label>
                        <div className="nc_box">
                            <input type="number"
                                className="form-control cn_input"
                                pattern="\d*"
                                id="Certifi_No"
                                placeholder="인증번호 6자리를 입력"
                                value={this.state.MemberModel.Certifi_No}
                                onChange={(e) => { this.handle_Change(e, 6); }}
                                onBlur={this.handle_Blur}
                            />
                            <div className="time_1">
                                <Timmer Minutes="5"
                                    Seconds="0"
                                    ref={this.refTimmer}
                                />
                            </div>
                            <button type="button" className={this.state.CertifiNumberOk === true ? "cn_button btn_inactive" : "cn_button btn_v1"} onClick={this.handleCertifi_Click}>인증 확인</button>
                        </div>
                        <div className={this.state.LabelMsg.Certifi_No_Show ? this.state.LabelMsg.Certifi_No_Css : "item_hide"}>{this.state.LabelMsg.Certifi_No_Msg}</div>
                    </div>
                    <div className="input_line">
                        <label>아이디</label>
                        <input type="text"
                            className="form-control"
                            maxLength="20"
                            id="Login_Id"
                            placeholder="문자/숫자 조합 최소 8자리를 입력해주세요."
                            value={this.state.MemberModel.Login_Id}
                            onChange={this.handle_Change}
                            onBlur={this.handle_Blur}
                        />
                        <div className={this.state.LabelMsg.Login_Id_Show ? this.state.LabelMsg.Login_Id_Css : "item_hide"}>{this.state.LabelMsg.Login_Id_Msg}</div>
                    </div>
                    <div className="input_line">
                        <label>비밀번호</label>
                        <input type={this.state.isEyeText}
                            className="form-control"
                            maxLength="20"
                            id="Password"
                            autoComplete="off"
                            placeholder="영문 대 소문자,특수기호 포함 8자리"
                            value={this.state.MemberModel.Password}
                            onChange={this.handle_Change}
                            onBlur={this.handle_Blur}
                        />
                        <div className={this.state.LabelMsg.Password_Show ? "input_txt" : "item_hide"}>{this.state.LabelMsg.Password_Msg}</div>
                        <div className={this.state.isEyeOpen === false ? "eye_close" : "eye_open"} onClick={() => { this.handleEye_Click('isEyeOpen') }}></div>
                    </div>
                    <div className="input_line">
                        <label>비밀번호 확인</label>
                        <input type={this.state.isEyeCheckText}
                            className="form-control"
                            maxLength="20"
                            id="PasswordCheck"
                            autoComplete="off"
                            placeholder="비밀번호를 확인해주세요."
                            value={this.state.MemberModel.PasswordCheck}
                            onChange={this.handle_Change}
                            onBlur={this.handle_Blur}
                        />
                        <div className={this.state.LabelMsg.PasswordCheck_Show ? "input_txt" : "item_hide"}>비밀번호가 일지하지않습니다.</div>
                        <div className={this.state.isEyeCheckOpen === false ? "eye_close" : "eye_open"} onClick={() => { this.handleEye_Click('isEyeCheckOpen') }}></div>
                    </div>
                    <div className="input_line">
                        <label>사업자등록번호</label>
                        <div className="nc_box">
                            <input type="tel"
                                className="form-control cn_input"
                                maxLength="12"
                                id="Org_No"
                                placeholder="사업자등록번호 입력 (-는 제외)"
                                value={this.state.MemberModel.Org_No}
                                onChange={(e) => { this.handle_Change(e, 12); }}
                                onBlur={this.handle_Blur}
                            />
                            <button type="button" className="cn_button btn_v1" onClick={this.handleBusinessFile} >사업자등록증<br />첨부{this.Org_File_Grp==="" ? "" : "(첨부됨)"}</button>
                        </div>
                        <div className={this.state.LabelMsg.Org_No_Show ? "input_txt" : "item_hide"}>사업자번호 형식이 잘못 되었습니다.</div>
                    </div>
                    <div className="input_line">
                        <label>상호명</label>
                        <input type="text"
                            className="form-control"
                            maxLength="50"
                            id="Org_Name"
                            placeholder="상호명을 입력하세요."
                            value={this.state.MemberModel.Org_Name}
                            onChange={this.handle_Change}
                            onBlur={this.handle_Blur}
                        />
                    </div>
                    <div className="input_line">
                        <label>사입자명</label>
                        <div className="nc_box">
                            <input type="text"
                                className="form-control cn_input"
                                maxLength="12"
                                placeholder="사입자 찾기버튼을 이용하세요."
                                value={this.state.Buyer_Org_Name}
                                onChange={this.handle_Change}
                                readOnly
                            />
                            <button type="button" className="cn_button btn_v1" onClick={(e) => { this.handleBuyerOpen_Click(e); }}>사입자<br />찾기</button>
                        </div>
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>입금자명</label>
                        <input type="text"
                            className="form-control"
                            maxLength="20"
                            id="Depo_Name"
                            placeholder="입금자명을 입력하세요." 
                            value={this.state.MemberModel.Depo_Name}
                            onChange={this.handle_Change}
                            onBlur={this.handle_Blur}
                        />
                    </div>
                    <div className="input_line">
                        <label>매장 우편번호</label>
                        <div className="nc_box">
                            <input type="text"
                                className="form-control cn_input"
                                maxLength="5"
                                id="Post_No"
                                placeholder="우편번호를 입력하세요."
                                value={this.state.MemberModel.Post_No}
                                onChange={this.handle_Change}
                                onBlur={this.handle_Blur}
                                readOnly
                            />
                            <button type="button" className="cn_button btn_v1" onClick={() => { Big3Common.ModalAlert(bootstrap, 'DaumPost'); }}>우편번호<br />검색</button>
                        </div>
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>매장 주소</label>
                        <input type="text"
                            className="form-control"
                            maxLength="100"
                            id="Addr_1"
                            placeholder="주소는 매장 우편번호 검색 후 자동입력됩니다."
                            value={this.state.MemberModel.Addr_1}
                            onChange={this.handle_Change}
                        />
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>매장 상세주소</label>
                        <input type="text"
                            className="form-control"
                            maxLength="50"
                            id="Addr_2"
                            placeholder="상세주소를 입력해주세요."
                            value={this.state.MemberModel.Addr_2}
                            onChange={this.handle_Change}
                        />
                        <div className="input_txt"></div>
                    </div>
                    <div className="agree_box">
                        <p>필수 가입정보를 입력해 주시고 서비스 정책에<br className="mobile_br" /> 동의해주세요.</p>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="Agreement_All"
                                    onChange={this.handle_Change}
                                />
                                <label className="form-check-label">
                                    약관에 모두 동의합니다.
                                </label>
                            </div>
                        </div>
                        <div className="line"></div>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Agreement_Yn1"
                                    onChange={this.handle_Change}
                                    checked={this.state.MemberModel.Agreement_Yn1}
                                />
                                <label className="form-check-label">
                                    [필수] 서비스 이용약관에 동의합니다.
                                </label>
                            </div>
                            <a href="#!" className="go_page" onClick={(e) => { this.handelTermsofservice_Click('Termsofservice'); e.preventDefault(); }}> </a>
                        </div>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Agreement_Yn2"
                                    onChange={this.handle_Change}
                                    checked={this.state.MemberModel.Agreement_Yn2}
                                />
                                <label className="form-check-label">
                                    [필수] 개인정보처리방침에 동의합니다.
                                </label>
                            </div>
                            <a href="#!" className="go_page" onClick={(e) => { this.handelTermsofservice_Click('Privacypolicy'); e.preventDefault(); }} > </a>
                        </div>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Optionagr_Yn"
                                    onChange={this.handle_Change}
                                    checked={this.state.MemberModel.Optionagr_Yn}
                                />
                                <label className="form-check-label">
                                    [선택] 마케팅수신약관에 동의합니다.
                                </label>
                            </div>
                            <a href="#!" className="go_page" onClick={(e) => { Big3Common.Util.OpenWindowLink('https://we.big3.kr/privacy2.html ', true); e.preventDefault(); }} > </a>
                        </div>
                    </div>
                    <div className="join_btn_line">
                        <button type="button" className="btn_v btn_v1" onClick={this.handleSave_Click }>가입하기</button>
                    </div>
                </div>
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                    AlertClick={this.handleAlert_Click} 
                />
                <DaumPost
                    id="DaumPost"
                    PostClick={(Zoneode, Address) => this.handlePost_Click(Zoneode, Address)}
                />
                {Buyerrender }
            </div>
        );
    }
}
